import { ProcessStep } from "../types";
import { computeMachineTime } from "./computeMachineTime";

type Params = {
  reworkRatio: number | null;
  totalQuantity: number;
  processStep: ProcessStep;
};

export const computeProcessTime = ({ reworkRatio, totalQuantity, processStep }: Params) => {
  const machineTime = computeMachineTime({
    processStep,
    reworkRatio: reworkRatio,
    totalQuantity,
  });

  return {
    processTime: machineTime,
  };
};
